import React, {Component} from 'react';
import {connect} from 'react-redux';

import './MarketingButtons.css';

class MarketingButtons extends Component {

    constructor(props) {

        super(props);
        this.state = {}
    }

    render() {

        const {data} = this.props.competition;

        // let marketingButtons = (
        //     <div
        //         style={{backgroundColor: data ? data.secondaryColor : '', color: data ? data.primaryColor : ''}}
        //         className='marketing-buttons'>
        //     </div>
        // );
        let marketingButtons = null;

        if (data && data.marketingButtons && data.marketingButtons.length) {

            marketingButtons = (
                <div
                    // style={{backgroundColor: data ? data.secondaryColor : '', color: data ? data.primaryColor : ''}}
                    className='marketing-buttons'>
                    {data.marketingButtons.map(mb =>
                        <a style={{
                            backgroundColor: data ? data.buttonColor : ''
                        }}
                           className='button margin'
                           target={mb.target}
                           href={mb.url}>
                            <div className="marketingButtonCont">
                                {mb.label}
                            </div>
                        </a>
                    )}
                </div>);
        }

        return marketingButtons;
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        competition: things.competition
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketingButtons);
